const ratings = [
  {
    name: "Debbie Quick-Roe",
    handle: "debbie.quickroe",
    message: "BEST THING EVERRRR and the delivery guys are awesome!  Have ordered the cobb salad 4 days in a row now!...",
    type: 'facebook',
  },
  {
    name: "Clifford Chi",
    handle: "clifford.chi.1",
    message: "Incredible concept and amazing service! ClusterTruck is the future of food delivery",
    type: 'facebook',
  },
  {
    name: "Chris Williams",
    handle: "cwillz",
    message: "No idea why I waited so long to try this. Great selection, fast friendly service, hot food was hot!",
    type: 'facebook',
  },
  {
    name: "Glenn A Blackwood",
    handle: "GlennABlackwood",
    message: "Best thing to happen to Indianapolis since the Colts won the Super Bowl. Cluster Truck is the Peyton Manning of super food. Only better, stronger, faster. They have the technology.",
    type: 'facebook',
  },
  {
    name: "Cara Johnson",
    handle: "cara.johnson.946",
    message: "We have been saddened and burned by other delivery apps. Cluster Truck is quality food delivered fast. What a concept!!",
    type: 'facebook',
  },
  {
    name: "Favored Hands",
    handle: null,
    message: "Wow!  I am originally from Chicago and a big food critic lol.  The food was amazing!! Fast delivery and cost efficient!  I recommend the 'what the pho' delicious and I will definitely order again!",
    type: 'facebook',
  },
  {
    name: "Kelly Musick",
    handle: "kelly.musick",
    message: "I ordered lunch for a group meeting. The website was super easy to use, they loved all the options, and delivery was amazingly fast. They all raved about the food as well. I will definitely use them in the future!",
    type: 'facebook',
  },
  {
    name: "Mary Wall Ryan",
    handle: "mwallryan",
    message: "My taste buds are satisfied, my belly is full and I was only away from my desk for 1 minute to meet my driver! I give ClusterTruck a 10 out of 5 stars!  My only regret...not ordering dessert!",
    type: 'facebook',
  },
  {
    name: "Samantha Rihm",
    handle: "samantha.rihm",
    message: "My order is always exceptionally fast! The food always exceeds my expectations and customer service is great. I love this service and recommend it to anyone in the downtown area.",
    type: 'facebook',
  },
  {
    name: "Morgan Galloway Daly",
    handle: "mogallowaydaly",
    message: "By the time I hit order and take the elevator down to the curb, the driver/biker is already there. It's MAGICAL. The food is sit down quality but I can eat it on my couch without pants on... #CompleteWin",
    type: 'facebook',
  },
  {
    name: "Imani Wisdom",
    handle: "imaniunique71",
    message: "The order process was easy and the service was super-fast! I recommend this place to all of my friends and family. I mean, real food delivered at curbside! ",
    type: 'facebook',
  },
  {
    name: "Jake Klemann",
    handle: "jake.klemann",
    message: "ClusterTruck is the bomb! Stuck here at Riley Children's Hospital on Sunday evening, all the internal restaurants closed. Made the order from their website. We got several different styles of food, burgers, pad tai, etc. The Uber type delivery guy was here in less that 30 minutes!",
    type: 'facebook',
  },
  {
    name: "Katie Donnar",
    handle: "katdonn",
    message: "Y'all, 2016 might not have the very best year, but it did bring us @clustertruck317 and maybe everything else was worth it.",
    type: 'twitter',
  },
  {
    name: "Cory Moyta",
    handle: "coeymota",
    message: "A return to working downtown means a return to @clustertruck317 lunches. 🙌",
    type: 'twitter',
  },
  {
    name: "Michael Leppert",
    handle: "MichaelLeppert",
    message: "@clustertruck317 just changed my life forever.",
    type: 'twitter',
  },
  {
    name: "Ari Kasle",
    handle: "AKasle_BU",
    message: "Just discovered @clustertruck317. Game changer",
    type: 'twitter',
  },
  {
    name: "Sarah M.",
    handle: "likesquirrel317",
    message: "Explaining the @clustertruck317 software/concept to some co workers. \"Oh wow, it's like a dream food delivery service.\" Nailed it.",
    type: 'twitter',
  },
]

export default ratings
